var map = {
	"./baker": 8417,
	"./baker.coffee": 8417,
	"./eagle": 8466,
	"./eagle.coffee": 8466,
	"./emperor": 8434,
	"./emperor.coffee": 8434,
	"./freecell": 1276,
	"./freecell.coffee": 1276,
	"./golf": 8118,
	"./golf.coffee": 8118,
	"./klondike": 4251,
	"./klondike.coffee": 4251,
	"./scorpion": 9660,
	"./scorpion.coffee": 9660,
	"./spider": 4104,
	"./spider.coffee": 4104,
	"./spiderette": 8198,
	"./spiderette.coffee": 8198,
	"./yukon": 4861,
	"./yukon.coffee": 4861
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2884;